import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    TextField,
    makeStyles
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { closeAddItemStatusDialog } from "./item-status-add-slice";
import { db } from "../../../../firebase";
import { useState } from "react";
import { addItemStatusService } from "./item-status-add-service";
import { showErrorSnackbar } from "../../../shared/snackbar/snackbar-slice";

const useStyles = makeStyles((theme) => ({
    button: {
        background: "#111111",
        color: "#fbbbd3",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    buttonText: {
        color: "#111111",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    title: {
        background:"#111111",
    },
    text: {
        color: "#111111",
    },
}));

const initiaFormData = {
    code: "",
    name: "",
    description: "",
};

const ItemStatusAdd = () => {
    const classes = useStyles();
    const showDialog = useSelector((state) => state.itemStatusAddSlice.showDialog);
    const isLoading = useSelector((state) => state.itemStatusAddSlice.isLoading);
    const [formData, setFormData ] = useState(initiaFormData);
    const dispatch = useDispatch();

    // handle input
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value
        });
    };

    // handle add submit
    const handleAddSubmit = async (e) => {
        e.preventDefault();  
       
        try {
            await addItemStatusService(dispatch, db, "item_status", formData);
          } catch (e) {
            dispatch(showErrorSnackbar("Something went wrong while trying to add."));
            console.error("ItemStatusAdd handleAddSubmit error: ", e);
          }
        handleAddClose();
    };

    // handle close add
    const handleAddClose = () => {
        setFormData(initiaFormData);
        dispatch(closeAddItemStatusDialog());
    };

    return (
        <Dialog
            open={showDialog}
        >
            <DialogTitle className={classes.title}>
                Add Item Status
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <TextField
                            id="filled-basic"
                            label="Code"
                            variant="filled"
                            fullWidth
                            name="code"
                            onChange={handleInputChange}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <TextField
                            id="filled-basic"
                            label="Name"
                            variant="filled"
                            fullWidth
                            name="name"
                            onChange={handleInputChange}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <TextField
                            id="filled-basic"
                            label="Description"
                            variant="filled"
                            fullWidth
                            name="description"
                            onChange={handleInputChange}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    className={classes.button}
                    onClick={handleAddSubmit}
                    disabled={isLoading}
                >
                    {
                        isLoading ? (
                            "Adding..."
                        ) : (
                            "Add"
                        )
                    }
                </Button>
                <Button
                    variant="text"
                    className={classes.buttonText}
                    onClick={handleAddClose}
                    disabled={isLoading}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ItemStatusAdd;